import React, {useState, useEffect, createContext, useContext} from 'react';
import SideMenu from '../../navigation/Menus/SideMenu';
import {Box} from '@chakra-ui/react';
import TopMenu from '../../navigation/Menus/TopMenu';
import {useLocation} from 'react-router-dom';

// This is used to change the title of a given screen, Since layout wraps every page it should be callable, but if a page is ever outside of layout it will have to wrap that too
const TitleContext = createContext();
const useTitle = () => {
  const context = useContext(TitleContext);
  if (!context) {
    throw new Error('useTitle must be used within a <Parent />');
  }
  return context;
};

const Layout = props => {
  const [title, setTitle] = useState('');
  const value = [title, setTitle];

  const [currentParent, setParent] = useState('Dashboard');
  const currentPage = useLocation();

  // This updates the top header/title of the screen
  useEffect(() => {
    const curScreens = props.screens.filter(screen => currentPage.pathname.includes(screen.screen));
    let curScreen = curScreens[0];

    if (curScreens.length > 1) {
      // will have to refactor this once more routes come in to play
      curScreen = curScreens[curScreens.length - 1];
    }
    if (curScreen != null && curScreen.title != '') {
      setParent(curScreen.title);
      setTitle(curScreen.title);
    }
  }, [currentPage]);

  // static displayName = Layout.name;
  return (
    <TitleContext.Provider value={value}>
      <TopMenu screens={props.screens} title={title} parent={currentParent} />
      <Box position="relative" textAlign="center" display={'flex'} mt="2">
        <SideMenu screens={props.screens} parent={currentParent} />
        <Box w="sm" maxW="9xl" flexGrow={1}>
          {props.children}
        </Box>
      </Box>
    </TitleContext.Provider>
  );
};

export {Layout, useTitle};
